module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "teak-cove-abstract-hayman-1.3add9189.jpg";